import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  component: RouteComponent,
  beforeLoad: async () => {
    throw redirect({ to: "/beheer" })
  },
})

function RouteComponent() {
  return <ScreenWrapper className="flex flex-col gap-4" showManagementMenu />
}
